<script setup lang="ts">
import { onMounted, ref } from 'vue';

interface Props {
	location: string;
}

const props = defineProps<Props>();
const spxHtmlElement = ref<HTMLElement | null>(null);

onMounted(() => {
	const element = document.getElementById(`SPX_${props.location}`);
	setTimeout(() =>{
		if (element && spxHtmlElement.value) {
			spxHtmlElement.value.appendChild(element);
			console.log(`SPX "${props.location}" moved`, element);
		}
	}, 250)

});
</script>

<template>
	<div ref="spxHtmlElement"></div>
</template>
